import { EDIT_TEMPLATE_URL, SITELESS_EDIT_TEMPLATE_URL } from '../config';
import { useDashboardFirstMetaSiteId } from './useDashboardFirstMetaSiteId';
import { useSiteCreationFolderId } from './useSiteCreationFolderId';

export const useEditUrl = (data: { metaSiteId: string }) => {
  const { metaSiteId } = data;
  const dashboardFirstMetaSiteId = useDashboardFirstMetaSiteId();
  const siteCreationFolderId = useSiteCreationFolderId();

  const editorUrl = new URL(
    dashboardFirstMetaSiteId ? SITELESS_EDIT_TEMPLATE_URL : EDIT_TEMPLATE_URL,
  );
  editorUrl.searchParams.append('originTemplateId', metaSiteId);
  if (dashboardFirstMetaSiteId) {
    editorUrl.searchParams.append('metaSiteId', dashboardFirstMetaSiteId);
  }
  if (siteCreationFolderId) {
    editorUrl.searchParams.append('siteCreationFolderId', siteCreationFolderId);
  }

  return editorUrl.href;
};
